module.exports = function isNull(value) {
  return value === null;
};
